import SC from 'styled-components'
import { Button } from 'ui/components/Buttons'

export const Inner = SC.div`
  width: 500px;
  padding: 27px 42px 27px 40px;
`

export const SaveButton = SC(Button)`
  margin-top: 27px;
`
